<template>
  <el-drawer
    :modal-append-to-body="false"
    append-to-body
    :title="title"
    :visible.sync="drawer"
    destroy-on-close
    :wrapperClosable="false"
    :close-on-press-escape="false"
    custom-class="widthCommon"
  >
    <el-tree ref="tree" :data="list" :props="defaultProps" default-expand-all node-key="id" :show-checkbox="true" @check="CheckChange" />
    <FixedTwoButton activeClass="widthCommon">
      <el-button size="small" @click="close">重置</el-button>
      <el-button type="primary" size="small" @click="submitForm">提交</el-button>
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import {
  groupCompanyDepartmentDropList,
  getDataPermissionCommunityDropList,
  staffGroupCompanyUserDropList,
  getNotSetWorkFlowCommunityDropList,
  notSetGroupCompanyWorkFlowStaffUserDropList,
} from '@/api/dropList'
export default {
  props: {
    title: {
      type: String,
      default: '服务项目',
    },
    sassUserId: {
      type: String,
      default: '',
    },
    selectIdList: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'community', // community项目,staff员工,department部门
    },
    filter: {
      type: Boolean,
      default: false,
    },
    filterParams: {
      type: Object,
      default: () => {},
    },
    staffParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      drawer: false,
      defaultProps: {
        children: 'child',
        label: 'name',
      },
      list: [],
      CheckedNodes: [],
      selected: {
        names: [],
        ids: [],
      },
    }
  },
  watch: {
    drawer(val) {
      if (!val) return
      this.init()
      if (this.list.length) this.selectData()
    },
  },
  methods: {
    async init() {
      this.type === 'community' ? await this.getCommunityList() : this.type === 'department' ? await this.getDepartmentList() : await this.staffGroupCompanyUserDropList()
      this.selectData()
    },
    // 获取项目
    async getCommunityList() {
      const { data: res } = this.filter ? await getNotSetWorkFlowCommunityDropList(this.filterParams) : await getDataPermissionCommunityDropList()
      if (!res) return (this.list = [])
      this.list = res
        .map(e => {
          return {
            child: e.communityItems
              .map(ele => {
                return { id: ele.communityId, name: ele.communityName, isSelect: ele.isSelect }
              })
              .filter(e => e !== undefined),
            name: e.organizationName,
            id: e.organizationId,
          }
        })
        .filter(e => e.child.length !== 0)
      this.defaultProps.label = 'name'
    },
    // 获取员工
    async staffGroupCompanyUserDropList() {
      const { data: res } = this.filter ? await notSetGroupCompanyWorkFlowStaffUserDropList(this.staffParams) : await staffGroupCompanyUserDropList(this.staffParams)
      if (!res) return (this.list = [])
      this.list = res
        .map(e => {
          return {
            child: e.user
              .map(ele => {
                return { id: ele.staffId, name: ele.staffRealName, departmentName: ele.departmentName }
              })
              .filter(e => e !== undefined),
            name: e.organizationName,
            id: e.organizationId,
          }
        })
        .filter(e => e.child.length !== 0)
      this.defaultProps.label = function (data, node) {
        const config = data.__config__ || data
        let departmentName = config.departmentName ? `${config.departmentName} ` : ''
        return departmentName + config.name
      }
    },
    // 获取部门
    async getDepartmentList() {
      const { data: res } = await groupCompanyDepartmentDropList()
      if (!res) return (this.list = [])
      this.list = res
        .map(e => {
          return {
            child: e.departmentDropListDTOS
              .map(ele => {
                return { id: ele.departmentId, name: ele.departmentName }
              })
              .filter(e => e !== undefined),
            name: e.organizationName,
            id: e.organizationId,
          }
        })
        .filter(e => e.child.length !== 0)
      this.defaultProps.label = 'name'
    },
    submitForm() {
      this.selected = {
        names: [],
        ids: [],
      }
      if (this.CheckedNodes.length) {
        this.CheckedNodes.forEach(e => {
          if (e.child) {
            e.child.forEach(ele => {
              this.selected.ids.push(ele.id)
              this.selected.names.push(ele.name)
            })
          } else {
            this.selected.ids.push(e.id)
            this.selected.names.push(e.name)
          }
        })
      }
      this.$emit('change', this.selected)
      this.CheckedNodes = []
      this.drawer = false
    },
    close() {
      this.CheckedNodes = []
      this.$refs.tree.setCheckedKeys([])
    },
    CheckChange(data, node) {
      this.CheckedNodes = this.$refs.tree.getCheckedNodes(false, false)
      node.checkedNodes.forEach(ele => {
        if (ele.child && ele.child.length) {
          this.deepClear(ele.child)
        }
      })
    },
    deepClear(data) {
      data.forEach((ele, index) => {
        if (ele.child && ele.child.length) {
          this.deepClear(ele.child)
        }
        this.CheckedNodes = [...this.CheckedNodes.filter(item => item.id !== ele.id)]
      })
    },
    selectData() {
      if (!this.selectIdList || !this.selectIdList.ids) return this.$refs.tree.setCheckedKeys([])
      this.CheckedNodes = this.selectIdList.ids.map((e, i) => {
        return {
          id: e,
          name: this.selectIdList.names[i],
        }
      })
      this.$refs.tree.setCheckedKeys(this.selectIdList.ids || [])
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-icon-caret-right:before {
  content: '';
  background-image: url('../../icons/up.png');
  width: 18px;
  height: 18px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  // position: absolute;
  // right: -100px;
}
::v-deep .el-tree-node__content {
  height: 56px;
  border-bottom: 1px solid #e5e6eb;
}
::v-deep .el-tree-node__children {
  .el-tree-node__content {
    padding-left: 42px !important;
  }
}
::v-deep .el-tree-node__expand-icon.expanded {
  transform: rotate(180deg);
}
::v-deep .el-tree-node__expand-icon.is-leaf::before {
  content: '';
  display: none;
  width: 16px;
  height: 23px;
  font-size: 16px;
  background-size: 16px;
}
::v-deep .el-tree-node__expand-icon {
  position: relative;
}
</style>
